(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/digital-tickets/digital-tickets-receipt/digital-tickets-receipt.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/digital-tickets/digital-tickets-receipt/digital-tickets-receipt.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  Fragment = _React.Fragment,
  useContext = _React.useContext,
  useEffect = _React.useEffect,
  useState = _React.useState;
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  GridRow = _svs$ui$ReactGrid.GridRow,
  GridCol = _svs$ui$ReactGrid.GridCol;
const PageWrapper = svs.ticket_partner.sharedComponents.pageWrapper.PageWrapper;
const WidgetArea = svs.ticket_partner.sharedComponents.widgetArea.WidgetArea;
const InformationPanels = svs.ticket_partner.sharedComponents.informationPanels.InformationPanels;
const Receipt = svs.ticket_partner.sharedComponents.receipt.Receipt;
const DIGITAL_RECEIPT = svs.ticket_partner.sharedComponents.receipt.constants.TEXTS.DIGITAL_RECEIPT;
const CLEAR_STATE = svs.ticket_partner.digitalTickets.actions.CLEAR_STATE;
const DIGITAL_TICKETS = svs.ticket_partner.constants.routes.DIGITAL_TICKETS;
const DigitalTicketsReceipt = _ref => {
  var _svs$ticket_partner$d;
  let history = _ref.history;
  const _useContext = useContext(svs.ticket_partner.DigitalTicketsContext),
    dispatch = _useContext.dispatch,
    state = _useContext.state;
  const _useContext2 = useContext(svs.ticket_partner.UserContext),
    companyDetailsPromise = _useContext2.companyDetailsPromise,
    isLoggedIn = _useContext2.isLoggedIn;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    email = _useState2[0],
    setEmail = _useState2[1];
  useEffect(async () => {
    if (isLoggedIn) {
      const _await$companyDetails = await companyDetailsPromise,
        companyDetails = _await$companyDetails.companyDetails;
      setEmail(companyDetails.eMail);
    } else {
      var _state$registerNew;
      setEmail(state === null || state === void 0 || (_state$registerNew = state.registerNew) === null || _state$registerNew === void 0 ? void 0 : _state$registerNew.eMail);
    }
    if (state.orderSuccess) {
      dispatch({
        type: CLEAR_STATE
      });
    } else {
      history.push(DIGITAL_TICKETS);
    }
  }, []);
  return React.createElement(Fragment, null, React.createElement(PageWrapper, null, React.createElement(Receipt, {
    articles: state.articles,
    email: email,
    isLoggedIn: isLoggedIn,
    type: DIGITAL_RECEIPT
  })), React.createElement(InformationPanels, {
    articles: (_svs$ticket_partner$d = svs.ticket_partner.data) === null || _svs$ticket_partner$d === void 0 || (_svs$ticket_partner$d = _svs$ticket_partner$d.articles) === null || _svs$ticket_partner$d === void 0 ? void 0 : _svs$ticket_partner$d.digitalTrissArticles
  }), React.createElement(PageWrapper, null, React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    className: "u-text-left",
    lg: 8,
    md: 10,
    sm: 12,
    xl: 6,
    xs: 12
  }, React.createElement(WidgetArea, {
    areaName: "digitalTrissAreaWidget"
  })))));
};
svs.ticket_partner.digitalTickets.DigitalTicketsReceipt = DigitalTicketsReceipt;

 })(window);